import { useTranslation } from 'react-i18next'

import Text from '../../Text'

import * as styles from './SelectDropdownEmpty.module.css'

function SelectDropdownEmpty({
  className = styles.SelectDropdownEmpty,
  text,
  ...restProps
}) {
  const { t } = useTranslation()

  return (
    <div {...restProps} className={className}>
      <Text isSecondary>{text || t('Select.NoDataKey')}</Text>
    </div>
  )
}

export default SelectDropdownEmpty
